module.exports = __webpack_public_path__ + "assets/images/project/menu/japan-thumb.jpg?v=7002d01c";